import UILink from '@components/ui/UILink'
import { DOMNode, Element, domToReact } from 'html-react-parser'
import ArticleText from './ArticleText'

interface ParticleLinkProps {
	dom: Element
}
const ParticleLink = ({ dom }: ParticleLinkProps) => {
	const {
		attribs: { class: className, href },
	} = dom
	return (
		<UILink
			className={className}
			href={href}
			sx={{
				fontSize: 'inherit',
				lineHeight: 'inherit',
			}}
		>
			<ArticleText>{domToReact(dom.children as Array<DOMNode>)}</ArticleText>
		</UILink>
	)
}
export default ParticleLink
